// Upload fields mark themselves while they hold an unfinished or failed upload.
// The form's submit button marked with data-js="dropzone-submit" stays
// disabled until no field is marked, so a pending removal is never saved alone.
export function setUploadBlocking(element, blocking) {
  element.toggleAttribute("data-upload-blocking", blocking);

  const form = element.closest("form");
  const submitButton = form?.querySelector("[data-js='dropzone-submit']");
  if (!submitButton) return;

  submitButton.disabled = !!form.querySelector("[data-upload-blocking]");
}
